import { useSrpContext } from '@/src/contexts'
import { Box, Button, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useCallback, useMemo } from 'react'

const SEOStopFilter = () => {
    const {
        SEOSrpData: { filterData }
    } = useSrpContext()
    const { stops: options } = filterData || {}
    const t = useTranslations('common')
    const title = t('stops', { s: 's' })
    const getStopLabelFromStopNumber = useCallback(
        (stops: number) => {
            return stops === 0 ? t('direct') : `${stops} ${stops > 1 ? t('stops', { s: 's' }) : t('stops', { s: '' })}`
        },
        [t]
    )
    const stopOptions = useMemo(() => {
        return options?.map((option: number, index: number) => {
            return {
                id: option,
                label: getStopLabelFromStopNumber(Number(option))
            }
        })
    }, [options, getStopLabelFromStopNumber])
    return (
        <Box>
            {/* Stops filter section */}
            <Box sx={{ p: 2, borderBottom: 1, borderColor: 'grey.200' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'grey.900' }}>
                        {title}
                    </Typography>
                </Box>

                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1 }}>
                    {stopOptions?.map((option: any) => {
                        const { id, label } = option
                        return (
                            <Button
                                key={id}
                                variant={'outlined'}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    py: 1,
                                    px: 0.5,
                                    borderRadius: 1,
                                    textAlign: 'center',
                                    transition: 'all 0.2s',
                                    minHeight: 48,

                                    borderColor: 'grey.200',
                                    bgcolor: 'background.default',
                                    color: 'grey.900'
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontSize: '0.875rem',
                                        fontWeight: 500,
                                        lineHeight: 1.2,
                                        textTransform: 'none'
                                    }}
                                >
                                    {label}
                                </Typography>
                            </Button>
                        )
                    })}
                </Box>
            </Box>
        </Box>
    )
}

export default SEOStopFilter
